import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { GroupActionService } from "../../../shared/group-action.service";
import {
	wsGroupActionBasicIncidentDataParm,
	wsGroupActionBasicIncidentDataInfo,
	wsGroupActionBasicIncidentInfractionDataInfo,
	wsGroupActionBasicIncidentPenaltyDataInfo,
	wsGroupActionBasicIncidentCalendarDataParm,
	wsGroupActionBasicIncidentCalendarDataInfo,
} from "../../../shared/GroupActionBasic";
import { StudentGroupsTableRefreshService } from "../../../shared/student-groups-table-refresh.service";
import * as moment from "moment";

@Component({
	selector: "caass-sgedit-basic",
	templateUrl: "./sgedit-basic.component.html",
	styleUrls: ["./sgedit-basic.component.css"],
})
export class SGEditBasicComponent implements OnInit {
	constructor(
		private dataService: GroupActionService,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig,
		private refreshService: StudentGroupsTableRefreshService
	) {}

	ngOnInit() {
		this.isBusy = true;

		//
		// Load data from parent
		//
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
		this.GroupActionID = this.dialogConfig.data.GroupActionID;

		this.UserID = this.user.userID;
		this.UserLevelID = this.user.UserLevelID;
		this.PersonID = this.user.personID;

		this.isAdd = false;

		//
		// Get data from DB
		//

		let parm: wsGroupActionBasicIncidentDataParm = {
			UserID: this.UserID,
			GroupActionID: this.GroupActionID,
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.GroupActionBasicIncidentGetData(parm).subscribe((data) => this.DisciplineBasicIncidentGetStudentData_Complete(data));
	}

	ngOnDestroy() {
		this.mp3Player.pause();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	user: any;
	SelectedGroup: any;

	SelectedPromptTypeID: any = 0;
	lstPromptType: any = [
		{
			ID: 0,
			Desc: "Automatically assigned to new group members",
		},
		{
			ID: 1,
			Desc: "Optional group action for new group members",
		},
	];

	GroupActionID: any;

	//From Discipline
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public PersonID: number = -1;
	public IncidentID: number = -1;
	public SchoolID: number = -1;
	public isAdd: boolean = false;

	public IncidentData: wsGroupActionBasicIncidentDataInfo;

	public lstInfractionItems: wsGroupActionBasicIncidentInfractionDataInfo[] = [];
	public SelectedInfraction: wsGroupActionBasicIncidentInfractionDataInfo = {
		InfractionID: -1,
		InfractionDesc: "",
		SchoolID: -1,
		PenaltyID: -1,
	}; // For HTML to not error on init

	public lstPenaltyItems: wsGroupActionBasicIncidentPenaltyDataInfo[] = [];
	public SelectedPenalty: wsGroupActionBasicIncidentPenaltyDataInfo = {
		PenaltyID: -1,
		PenaltyDesc: "",
		SchoolID: -1,
		isSusp: false,
		MinDurationDayCount: 1,
		MaxDurationDayCount: 1,
		AlertID: -1,
		AlertDesc: "",
		SoundData: "",
	}; // For HTML to not error on init

	public isConfigError: boolean = false;

	public rAdminName: string = "";
	public rIncidentDT: Date = null;
	public rContinueAlert: boolean = false;
	public rIsUseDayCount: boolean = false;
	public risSusp: boolean = false;
	public rMinDurationDayCount: number = 1;
	public rMaxDurationDayCount: number = 1;

	public selectedRadioValue: string = "1";

	//	RadioValue1
	public rSuspNbrDays1: number = 1;
	public rStartDate1: Date = null;
	public rEndDate1: Date = null;

	//	RadioValue2
	public rSuspNbrDays2: number = 1;
	public rStartDate2: Date = null;
	public rEndDate2: Date = null;

	//	Sound Player
	public mp3Player: any = new Audio();

	//	Error Messaging
	public ErrorMessage: string = "";

	// Portal Apps
	public ParentPortalSendNotification: boolean = false;
	public StudentPortalSendNotification: boolean = false;
	public StaffPortalSendNotification: boolean = false;

	DisciplineBasicIncidentGetStudentData_Complete(data: any) {
		this.IncidentData = data;

		this.lstInfractionItems = this.IncidentData.InfractionItems;
		this.lstPenaltyItems = this.IncidentData.PenaltyItems;

		this.rAdminName = this.IncidentData.AdminName;
		this.rContinueAlert = this.IncidentData.ContinueAlert;

		this.rIsUseDayCount = this.IncidentData.IsUseDayCount;
		this.rSuspNbrDays1 = this.IncidentData.DayCount;
		this.rSuspNbrDays2 = this.IncidentData.DayCount;

		this.rStartDate1 = null; // Set Later
		this.rEndDate1 = null; // Set Later
		this.rStartDate2 = null; // Set Later
		this.rEndDate2 = null; // Set Later

		this.SelectedPromptTypeID = this.IncidentData.PromptType;

		if (this.rIsUseDayCount == false) {
			this.selectedRadioValue = "1"; // Date Range
		} else {
			this.selectedRadioValue = "2"; // Day Count
		}

		//
		//	Make Sure At Least 1 Infraction and 1 Penalty Item is Set To Basic Mode
		//
		if (this.lstInfractionItems.length == 0) {
			this.ErrorMessage = "No infractions are configured for Basic Mode. Please configure Basic Mode infractions in School Setup to continue.";
			this.isConfigError = true;
			this.isBusy = false;
			return;
		}

		if (this.lstPenaltyItems.length == 0) {
			// actions
			this.ErrorMessage = "No actions are configured for Basic Mode. Please configure Basic Mode actions in School Setup to continue.";
			this.isConfigError = true;
			this.isBusy = false;
			return;
		}

		// Start / End Date
		if (this.IncidentData.StartDate != null) {
			this.rStartDate1 = new Date(this.IncidentData.StartDate); // Must do new for this to work
			this.rStartDate2 = new Date(this.IncidentData.StartDate); // Must do new for this to work
		}

		if (this.IncidentData.EndDate != null) {
			this.rEndDate1 = new Date(this.IncidentData.EndDate); // Must do new for this to work
			this.rEndDate2 = new Date(this.IncidentData.EndDate); // Must do new for this to work
		}

		// SET IncidentDT
		if (this.IncidentData.IncidentDT == null) {
			this.rIncidentDT = null;
		} else {
			this.rIncidentDT = new Date(this.IncidentData.IncidentDT); // Must do new for this to work
		}

		//
		//	Select Default Infraction
		//
		this.SelectedInfraction = this.lstInfractionItems[0];

		this.lstInfractionItems.forEach((item) => {
			if (item.InfractionID == this.IncidentData.InfractionID) {
				this.SelectedInfraction = item;
			}
		});

		//
		//	Select Default Penalty
		//
		this.SelectedPenalty = this.lstPenaltyItems[0];

		this.lstPenaltyItems.forEach((item) => {
			if (item.PenaltyID == this.IncidentData.PenaltyID) {
				this.SelectedPenalty = item;
			}
		});

		this.risSusp = this.SelectedPenalty.isSusp;
		this.rMinDurationDayCount = this.SelectedPenalty.MinDurationDayCount;
		this.rMaxDurationDayCount = this.SelectedPenalty.MaxDurationDayCount;

		this.ParentPortalSendNotification = this.IncidentData.ParentPortalSendNotification;
		this.StudentPortalSendNotification = this.IncidentData.StudentPortalSendNotification;
		this.StaffPortalSendNotification = this.IncidentData.StaffPortalSendNotification;

		this.isBusy = false;
	}

	////////////////////////////////////////////
	// Buttons (ADD on PARENT)
	////////////////////////////////////////////
	onPlay() {
		if (this.SelectedPenalty.SoundData.length > 0) {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedPenalty.SoundData);
			this.mp3Player.play();
		}
	}

	onStop() {
		this.mp3Player.pause();
	}

	DisciplineBasicIncidentAdd_Complete(data: any) {
		this.isBusy = false;
		// this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.AllClear(data) == true) {
			//Success Dialog
			this.confirmationService.confirm({
				key: "basic",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Basic Group Action Incident was updated successfully",
				header: "Success",
				icon: "fa",
				accept: () => {
					this.refreshService.GroupActionRefreshChanged(moment(new Date()).format("MM/DD/YYYY HH:mm:ss"));
					this.ref.close(1);
				},
			});
		} else {
			//Fail Dialog
			this.confirmationService.confirm({
				key: "basic",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Could Not update the Group Action Incident",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		}
	}

	DisciplineBasicIncidentUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onInfractionChange(e: any) {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		//
		//	Select Default Penalty
		//
		this.lstPenaltyItems.forEach((item) => {
			if (item.PenaltyID == this.SelectedInfraction.PenaltyID) {
				this.SelectedPenalty = item;
			}
		});

		this.risSusp = this.SelectedPenalty.isSusp;
		this.rMinDurationDayCount = this.SelectedPenalty.MinDurationDayCount;
		this.rMaxDurationDayCount = this.SelectedPenalty.MaxDurationDayCount;

		if (this.SelectedPenalty.AlertID > 0) {
			this.rContinueAlert = true;
		} else {
			this.rContinueAlert = false;
		}
	}

	onPenaltyChange(e: any) {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		this.risSusp = this.SelectedPenalty.isSusp;
		this.rMinDurationDayCount = this.SelectedPenalty.MinDurationDayCount;
		this.rMaxDurationDayCount = this.SelectedPenalty.MaxDurationDayCount;

		if (this.SelectedPenalty.AlertID > 0) {
			this.rContinueAlert = true;
		} else {
			this.rContinueAlert = false;
		}

		if (this.risSusp == true) {
			this.onRadioChange();
		}
	}

	onRadioChange() {
		if (this.selectedRadioValue == "1") {
			this.ValidateOption1Change();
		} else {
			this.ValidateOption2Change();
		}
	}

	onStartDate1Change(val) {
		this.rStartDate1 = val;
		this.ValidateOption1Change();
	}

	onEndDate1Change(val) {
		this.rEndDate1 = val;
		this.ValidateOption1Change();
	}

	ValidateOption1Change() {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		if (this.rStartDate1 != null) {
			if (this.rStartDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rEndDate1 != null) {
			if (this.rEndDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid End Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rStartDate1 > this.rEndDate1) {
			this.ErrorMessage = "Start Date cannot be greater than End Date";
			return;
		}

		let parm: wsGroupActionBasicIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate1,
			EndDate: this.rEndDate1,
			IsUseDayCount: false,
			DayCount: -1,
		};

		this.isBusy = true;
		this.dataService.GroupActionBasicIncidentGetCalendarData(parm).subscribe((data) => this.DisciplineBasicIncidentGetCalendarData_Complete(data));
	}

	onSuspNbrDays2() {
		this.ValidateOption2Change();
	}

	onStartDate2Change(val) {
		this.rStartDate2 = val;
		this.ValidateOption2Change();
	}

	onEndDate2Change(val) {
		this.rEndDate2 = val;
		this.ValidateOption2Change();
	}

	ValidateOption2Change() {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		if (isNaN(Number(this.rSuspNbrDays2))) {
			this.ErrorMessage = "Number of days is not a number.";
			return;
		}

		if (Number(this.rSuspNbrDays2 < 1)) {
			this.ErrorMessage = "Number of days must be greater than 0.";
			return;
		}

		if (this.rSuspNbrDays2 < this.rMinDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			return;
		}

		if (this.rSuspNbrDays2 > this.rMaxDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			return;
		}

		if (this.rStartDate2 != null) {
			if (this.rStartDate2.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		let parm: wsGroupActionBasicIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate2,
			EndDate: null,
			IsUseDayCount: true,
			DayCount: this.rSuspNbrDays2,
		};

		this.isBusy = true;
		this.dataService.GroupActionBasicIncidentGetCalendarData(parm).subscribe((data) => this.DisciplineBasicIncidentGetCalendarData_Complete(data));
	}

	DisciplineBasicIncidentGetCalendarData_Complete(data: any) {
		var CalendarData: wsGroupActionBasicIncidentCalendarDataInfo;

		CalendarData = data;

		if (CalendarData.IsUseDayCount == true) {
			this.rEndDate2 = new Date(CalendarData.SuspEndDate); // Must do new for this to work
		} else {
			this.rSuspNbrDays1 = CalendarData.SuspNbrDays;

			if (this.rSuspNbrDays1 < this.rMinDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			}

			if (this.rSuspNbrDays1 > this.rMaxDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			}
		}

		if (CalendarData.isCalendarValid == false) {
			this.ErrorMessage = "Open calendar days does not support Suspension Days. First update school calendar.";
		}

		this.isBusy = false;
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}
}
